const PageType = {
  Landing: 'landing',
  About: 'about',
  PressRelease: 'pressReleases',
  NewsArticle: 'inTheNews',
};

export default PageType;
